export default __webpack_public_path__ + "static/media/beeHealthyGardensMobile.7b5e63be.jpg";